import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { ILoyaltyPoint, ILoyaltyPointRequest } from "@ontime/types";

const API_URL = (organizationId: string) => `${ApiURL()}/organizations/${organizationId}/loyaltyPoint`;

class LoyaltyPointService {

    async GetList(organizationId: string, showDeleted: boolean = false): Promise<ILoyaltyPoint[]> {
        const response = await axios.get<ILoyaltyPoint[]>(API_URL(organizationId), {
            headers: AuthHeader(),
            params: { showDeleted }
        });
        return response.data;
    }

    async Get(organizationId: string, loyaltyPointId: string): Promise<ILoyaltyPoint> {
        const response = await axios.get<ILoyaltyPoint>(`${API_URL(organizationId)}/${loyaltyPointId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, input: ILoyaltyPointRequest): Promise<ILoyaltyPoint> {
        const response = await axios.post<ILoyaltyPoint>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, input: ILoyaltyPointRequest): Promise<ILoyaltyPoint> {
        const response = await axios.put<ILoyaltyPoint>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, loyaltyPointId: string, currentIsDeleted: boolean): Promise<{ loyaltyPointId: string }> {
        const response = await axios.delete<{ loyaltyPointId: string }>(`${API_URL(organizationId)}/${loyaltyPointId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new LoyaltyPointService();